export interface StatusServicosModel {
    name?: string;
    descricao?: string;
}

export const statusServicos: StatusServicosModel[] = [
    { name: "EM_ANDAMENTO", descricao: "Em Andamento" },
    { name: "FINALIZADO", descricao: "Finalizado" },
    { name: "PAGO", descricao: "Pago" },
    { name: "CANCELADO_PRESTADOR", descricao: "Cancelado Prestador" },
    { name: "CANCELADO_CLIENTE", descricao: "Cancelado Cliente" },
    { name: "PENDENTE", descricao: "Pendente" },
];